import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import _ from 'underscore';
import { t } from 'services/translation';
import Dropdown from '../';

const GuestsDropdown = createReactClass({
  mixins: [PureRenderMixin],
  displayName: 'GuestsDropdown',

  propTypes: {
    max: PropTypes.number,
    min: PropTypes.number,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    icon: PropTypes.node,
    optionsLabel: PropTypes.string,
    disabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      max: 10,
      min: 1,
      value: null,
      icon: <i className="af-angle-down-ar icon icon-anyfont" />,
      optionsLabel: '',
      optionsLabelPlural: '',
      disabled: false,
    };
  },

  _buildDropdownOptions() {
    let label;
    return _.range(this.props.min, this.props.max + 1).reduce(
      (options, option) => {
        if (this.props.optionsLabel) {
          label =
            option === 1 ? this.props.optionsLabel : this._optionsLabelPlural();
          options[option] = `${option} ${label}`;
        } else {
          options[option] = `${option}`;
        }

        return options;
      },
      {}
    );
  },

  _optionsLabelPlural() {
    if (!!this.props.optionsLabelPlural) {
      return this.props.optionsLabelPlural;
    }
    return this.props.optionsLabel + 's';
  },

  onChangeProxy() {
    const val = parseInt(arguments[1]);
    const args = Array.prototype.slice.call(arguments);

    args.splice(1, 1, val);
    this.props.onChange?.apply(null, args);
  },

  render() {
    const { name, value, theme, icon, disabled, ariaLabelledBy } = this.props;
    const dropdownProps = {
      'data-testid': 'guest-count-dropdown',
      name,
      options: this._buildDropdownOptions(),
      value,
      theme,
      placeholder: `${t('HOW_MANY')}?`,
      onChange: this.onChangeProxy,
      icon,
      disabled,
      ariaLabelledBy,
    };

    return <Dropdown {...dropdownProps} />;
  },
});

export default GuestsDropdown;
